import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { AuthSyncService } from '../auth/auth-sync.service';

export interface ErpModuleCard {
  id: string;
  title: string;
  description: string;
  icon: string;
  color: string;
  baseUrl: string;
  defaultRoute: string;
  sameApp?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ModuleNavigationService {
  constructor(private router: Router, private authSync: AuthSyncService) {}

  getModules(): ErpModuleCard[] {
    return environment.erpModules ?? [];
  }

  getCurrentModuleId(): string {
    return environment.currentModule ?? '';
  }

  isCurrentModule(moduleId: string): boolean {
    return moduleId === this.getCurrentModuleId();
  }

  getHubUrl(): string {
    return ((environment as { hubUrl?: string }).hubUrl || 'https://front-hub.agrosilo-solutions.com').replace(/\/$/, '');
  }

  goToHubHome(): void {
    const auth = this.authSync.buildAuthQueryParams();
    const authPart = auth ? `?auth=${auth}` : '';
    window.location.href = `${this.getHubUrl()}/home${authPart}`;
  }

  openModule(module: ErpModuleCard): void {
    if (this.getCurrentModuleId() === 'hub') {
      window.location.href = this.buildModuleUrl(module);
      return;
    }

    if (this.isCurrentModule(module.id) || module.sameApp) {
      void this.router.navigateByUrl(module.defaultRoute);
      return;
    }

    window.location.href = this.buildModuleUrl(module);
  }

  private buildModuleUrl(module: ErpModuleCard): string {
    const base = module.baseUrl.replace(/\/$/, '');
    const auth = this.authSync.buildAuthQueryParams();
    const goto = encodeURIComponent(module.defaultRoute);
    const authPart = auth ? `auth=${auth}&` : '';
    return `${base}/home?${authPart}goto=${goto}`;
  }
}
